import React, { useCallback, useMemo } from 'react';
import { seoEnable } from 'reactApp/appHelpers/featuresHelpers/features/seoEnable';
import { useFeaturesEnabled } from 'reactApp/components/SharingWindow/blocks/PaidFeaturesBlock/hooks/useFeautresEnabled';
import { AutoDelete } from 'reactApp/components/SharingWindow/blocks/Weblink/AutoDelete/AutoDelete';
import { ChangeDesign } from 'reactApp/components/SharingWindow/blocks/Weblink/ChangeDesign/ChangeDesign';
import { PublicPassword } from 'reactApp/components/SharingWindow/blocks/Weblink/PublicPassword/PublicPassword';
import type { EFrom, SendSharingContentAnalytics } from 'reactApp/components/SharingWindow/Sharing.types';
import { XrayItemType } from 'reactApp/modules/home/home.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { gaSuffix } from 'reactApp/ui/EmptyFolder/EmptyFolder.types';
import { sendPaymentGa } from 'reactApp/utils/paymentGa';

import { PaidFeaturesWrapper } from './PaidFeaturesWrapper';

export enum SharingWidnowContext {
    SHARRING = 'sharing',
    TAB = 'tab',
    ONBOARDING = 'onboarding',
}
interface PaidFeatureBlockProps {
    context: SharingWidnowContext;
    itemStorage?: EStorageType;
    isPhone?: boolean;
    isTabDesing?: boolean;
    from: EFrom;
    id: string;
}

export function PaidFeatureBlock({ context, itemStorage, isPhone, isTabDesing, from, id }: PaidFeatureBlockProps) {
    const {
        showAutoDeleteSettings,
        showChangeDesign,
        showChangePassword,
        item,
        isFolder,
        isAutodeleteFeatureEnabled,
        isAutodeletePromoFeatureEnabled,
        isWeblinkOpened,
    } = useFeaturesEnabled({ itemStorage, isPhone, from, id });
    const isOnboarding = context === SharingWidnowContext.ONBOARDING;

    const xrayItemType = useMemo(() => {
        if (itemStorage === EStorageType.albums) {
            return XrayItemType.album;
        } else if (item?.isFolder) {
            return XrayItemType.folder;
        }
        return XrayItemType.file;
    }, [item?.isFolder, itemStorage]);

    const sendSharingContentAnalytics = useCallback<SendSharingContentAnalytics>(({ action, label }) => {
        sendPaymentGa({ eventCategory: 'enable-sharing', action, label });
    }, []);

    const onDropdownClick = useCallback(() => {
        sendSharingContentAnalytics({ action: 'auto-delete', label: 'click' });
    }, [sendSharingContentAnalytics]);

    return (
        <PaidFeaturesWrapper tooltipOuter={context === SharingWidnowContext.TAB} isOnboarding={isOnboarding} isFolder={isFolder}>
            {showChangeDesign && <ChangeDesign isOnboardingDesign isTabsDesign={isTabDesing} isOnboarding={isOnboarding} item={item} />}
            {/* tempexp_17605-next-line */}
            {showChangePassword && (
                <PublicPassword isOnboardingDesign isTabsDesign={isTabDesing} isOnboarding={isOnboarding} forcePromo={false} item={item} />
            )}
            {showAutoDeleteSettings && (
                <AutoDelete
                    isOnboardingDesign
                    isTabs={isTabDesing}
                    isOnboarding={isOnboarding}
                    item={item}
                    disabled={!isAutodeleteFeatureEnabled && isAutodeletePromoFeatureEnabled && isWeblinkOpened}
                    gaSuffix={gaSuffix}
                    onDropdownClick={onDropdownClick}
                    disabledBySeo={item?.weblinkSeoEnabled && seoEnable}
                    xrayItemType={xrayItemType}
                />
            )}
        </PaidFeaturesWrapper>
    );
}
